'use strict';

class ErrorHandler {

  handleError(message) {
    this.message = message;
    return {
      error: 'error_handler',
      message,
    };
  }

  removeMicrosoftDetails(requestResult) {
    delete requestResult.options;
    delete requestResult.response;    
    return Promise.reject(requestResult);
  }

}

module.exports = new ErrorHandler();
